import { useState, useEffect, useRef } from "react";
import { findBoundsOfArrayOfItems } from "../../../refractCommon/miro/findBoundsOfArrayOfItems";
import { sortLeftRightTopBottom } from "../../../refractCommon/miro/sortLeftRightTopBottom";

const { board } = window.miro;

function Circle({ boardSelection, handleSetBoardSelection }) {
  const [circleItems, setCircleItems] = useState([]);
  const [toolOpen, setToolOpen] = useState(false);
  const [setHeight, setHeightState] = useState("0px");

  const content = useRef(null);

  useEffect(() => {
    runSelectItemsForCircle(boardSelection);
  }, [boardSelection]);

  function handleToggleOpen() {
    setToolOpen(!toolOpen);
    setHeightState(toolOpen ? "0px" : `${content.current.scrollHeight}px`);
  }

  // C I R C L E
  // CIRCLE TOOL APPLICABLE ITEM TEYMES
  async function runSelectItemsForCircle(selection) {
    if (!selection) {
      return [];
    }
    if (selection.length === 0) {
      setCircleItems(selection);
      return selection;
    }
    if (selection.length > 0) {
      let reorderedList = sortLeftRightTopBottom(selection);

      let filteredSelection = reorderedList.filter(
        (item) =>
          (item.type === "sticky_note" && item.parentId === null) ||
          (item.type === "text" && item.parentId === null) ||
          (item.type === "card" && item.parentId === null) ||
          (item.type === "shape" && item.parentId === null) ||
          (item.type === "frame" && item.childrenIds.length === 0) ||
          (item.type === "image" && item.parentId === null)
      );

      setCircleItems(filteredSelection);
      return filteredSelection;
    }
  }
  // THE CIRCLE ITEM TYPE ICONS TO MATCH
  let circleItemTypeIcons = (
    <div className="cs4 ce12 grid mt--8">
      <div className="m2 icon icon-rectangle cs1"></div>
      <div className="m2 icon icon-sticky-bulk cs2"></div>
      <div className="m2 icon icon-card cs3"></div>
      <div className="m2 icon icon-frame cs4"></div>
      <div className="m2 icon icon-text cs5"></div>
      <div className="m2 icon icon-image cs6"></div>
    </div>
  );

  async function runCircle() {
    // GAURD CLAUSES
    // we don't have a selection set
    if (boardSelection.length === 0) {
      return;
    }
    // our item count is too small to be worth making a circle
    if (circleItems.length < 3) {
      return;
    }

    // LETS MAKE THAT CIRCLE
    // maybe we find a bounds and a centroid
    // then use that centroid as center
    // then larger of width or height * 0.5 as radius
    let selection = await board.getSelection();

    let filteredSelection = await runSelectItemsForCircle(selection);

    let boardSelectionBounds = findBoundsOfArrayOfItems(filteredSelection);
    let circleCenterX = boardSelectionBounds.centroidX;
    let circleCenterY = boardSelectionBounds.centroidY;

    let circleRadius =
      Math.max(boardSelectionBounds.width, boardSelectionBounds.height) * 0.5;

    // then run the point-finding algorithm
    let theta = (Math.PI * 2) / filteredSelection.length;

    for (const [index, item] of filteredSelection.entries()) {
      let currentAngle = theta * index;
      item.x = circleCenterX + circleRadius * Math.sin(currentAngle);
      item.y = circleCenterY - circleRadius * Math.cos(currentAngle);
      await item.sync();
    }
    let updatedBoardSeletion = await board.getSelection();
    handleSetBoardSelection(updatedBoardSeletion);
  }

  return (
    <div id="circle-tool" className="grid tool-section mt-0 pb-0">
      <div
        id="scale-tool-header"
        className={"grid cs1 ce12 mt-0 cursor-pointer"}
        onClick={(event) => {
          handleToggleOpen();
        }}>
        <div className="cs1 icon m2 icon-oval mb-0"></div>
        <h3 className="h3 cs2 ce11 mb-0 mt-0">Circle</h3>
        <div
          className={
            "cs12 icon m2 mb-0 mt-0 cursor-pointer" +
            " " +
            (toolOpen === false ? "icon-arrow-right" : "icon-arrow-down")
          }></div>
      </div>
      <div
        id="accordion-content"
        ref={content}
        style={{ maxHeight: `${setHeight}` }}
        className="cs1 ce12 grid accordion">
        <div id="accordion-margin" className="cs1 ce12 grid mb-8">
          <p className="p-medium mt-0 pt-0 cs1 ce12 mb-0">
            Arrange items in a circle. Leftmost becomes topmost, then left to
            right = clockwise placement.
          </p>
          <div
            id="circle-works-on"
            className="help-container grid cs1 ce12 mt-8 pt-16">
            <p className="p-medium cs1 ce3 mb-0 mt--8 line-height-tight">
              Works on: <br /> 3 or more
            </p>
            {circleItemTypeIcons}
            {circleItems.length < 3 ? (
              <p
                className="p-medium cs1 ce12 align-center mb-0 mt-0 "
                style={{
                  color: "var(--red900)",
                }}>
                Select <b>3 or more items</b> of the above types.
              </p>
            ) : (
              <p className="p-medium cs1 ce12 align-center mb-0 mt-0 ">
                <b>{circleItems.length} circle-able</b> items selected.
              </p>
            )}
          </div>
          {/*  */}
          <button
            type="button"
            className="button button-primary button-small cs1 ce12 mb-0 mt-8"
            onClick={runCircle}>
            Make Circle
          </button>
        </div>
      </div>
    </div>
  );
}

export default Circle;
